export class contactUsCMSModel {
    contactus: any;
}


export class contactUsEntryIdObj {
  	entryIds = [
      { id:'2NvyZSgLLAAJcGyc6HZEhX', text : 'contactus'}
  	];
}